/**
 * Jotai atoms for global source viewer state.
 *
 * Any component can open the source viewer by setting the viewingSource atom.
 * The SourceViewerSheet component renders the viewer as a Sheet overlay.
 */
import type { ReadingModalState, ViewerSource } from '@heidi/evidence/contracts';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// ===== TYPES =====

// The payload shapes are citation vocabulary and live on the Evidence contracts
// door; re-exported here so this module's importers stay untouched.
export type { ReadingModalState, ViewerSource } from '@heidi/evidence/contracts';

// ===== ATOMS =====

/**
 * The source currently being viewed in the global source viewer.
 * Set to null to close the viewer.
 */
export const viewingSourceAtom = atom<ViewerSource | null>(null);

/**
 * Whether the reading timer is hidden in the source viewer.
 * Persisted to localStorage so the preference survives page refreshes.
 * When true, the timer is hidden until the user clicks "Show timer".
 */
export const sourceViewerTimerHiddenAtom = atomWithStorage<boolean>(
  'heidi-source-viewer-timer-hidden',
  true
);

// ===== READING MODAL =====

/**
 * When set, shows a centered "reading in new tab" modal with just the timer.
 * This is triggered when the user clicks "Open in new tab" from the source viewer sheet.
 * The timer continues from where it was in the sheet.
 */
export const readingModalAtom = atom<ReadingModalState | null>(null);
